<script setup>
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import PagesTable from "@/components/admin/kit/pages/partials/PagesTable.vue";
import PaginationButtons from "@/components/global-themed/PaginationButtons.vue";
import {handlePageChange, useKitPages} from "@/composables/kit-pages/useKitPages";

const props = defineProps({
  websiteId: {
    required: true,
    type: Number,
  },
});

const {currentPage, queryMeta} = useKitPages(props.websiteId);
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-y-8">
      <div class="tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex tw-items-center tw-gap-4">
          <KitIcon class="tw-h-14" />
          <h1 class="tw-font-bold tw-text-4.5xl tw-text-neutral-900">
            Kit Pages
          </h1>
        </div>
      </div>

      <div
        class="tw-bg-white tw-p-8 tw-rounded-lg tw-flex tw-flex-col tw-gap-y-8 tw-items-center"
      >
        <PagesTable
          :website-id="websiteId"
        />
        <PaginationButtons
          v-if="queryMeta.last_page"
          :last-page="queryMeta.last_page"
          :current-page="currentPage"
          @change="(page) => handlePageChange(page)"
        />
      </div>
    </div>
  </div>
</template>
